<template>
  <div style="background: mediumpurple">
    <h2>Devices</h2>
    <h3>Video</h3>
    <div v-if="currentVideo">Current video: {{ currentVideo.label }}</div>
    <select v-if="videoDevices.length > 0" :value="currentVideoId" @change="setVideo($event.target.value)" name="videoDevice"
            id="videoDevice">
      <option value="" disabled>Select one</option>
      <option :value="device.deviceId" v-for="device in videoDevices" :key="device.deviceId">
        {{ device.label }}
      </option>
    </select>
    <div v-else>No video devices</div>

    <h3>Audio</h3>
    <div v-if="currentAudio">Current audio: {{ currentAudio.label }}</div>
    <select v-if="audioDevices.length > 0" :value="currentAudioId" @change="setAudio($event.target.value)" name="audioDevice"
            id="audioDevice">
      <option value="" disabled>Select one</option>
      <option :value="device.deviceId" v-for="device in audioDevices" :key="device.deviceId">
        {{ device.label }}
      </option>
    </select>
    <div v-else>No audio devices</div>
  </div>
</template>

<script>
export default {
  name: "SelectDevices",
  computed: {
    currentVideoId() {
      return this.currentVideo?.deviceId
    },
    currentAudioId() {
      return this.currentAudio?.deviceId
    },
    currentVideo() {
      return this.$store.state.meeting.currentVideo
    },
    currentAudio() {
      return this.$store.state.meeting.currentAudio
    },
    videoDevices() {
      return this.$store.state.meeting.videoDevices
    },
    audioDevices() {
      return this.$store.state.meeting.audioDevices
    },
  },
  methods: {
    setVideo(deviceId) {
      this.$store.dispatch("setVideoDevice", deviceId)
    },
    setAudio(deviceId) {
      this.$store.dispatch("setAudioDevice", deviceId)
    }
  }
}
</script>
